// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  brown: '#2C1D14', muted: '#9A7B68', amber: '#B8721F',
}


export default function NDAPage() {
  return (
    <div style={{
      minHeight: '100vh', background: C.bg,
      padding: '40px 16px 80px', fontFamily: 'Georgia, serif',
    }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; }
          .nda-card { box-shadow: none !important; border: none !important; }
        }
      `}</style>

      <div className="nda-card" style={{
        maxWidth: '720px', margin: '0 auto',
        background: C.card, borderRadius: '16px',
        border: `1px solid ${C.border}`,
        boxShadow: '0 8px 40px rgba(44,29,20,0.10)',
        padding: '48px 52px',
      }}>
        {/* Header */}
        <div style={{ marginBottom: '32px' }}>
          <div style={{ fontSize: '13px', color: C.amber, fontFamily: 'Calibri, sans-serif', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px' }}>
            Casavio Beta Program
          </div>
          <h1 style={{ fontSize: '26px', fontWeight: '700', color: C.brown, margin: '0 0 10px' }}>
            Non-Disclosure Agreement
          </h1>
          <p style={{ fontSize: '14px', color: C.muted, fontFamily: 'Calibri, sans-serif', margin: 0, lineHeight: 1.6 }}>
            Please read this agreement carefully before accepting at signup. By checking the NDA box, you agree to the terms below.
          </p>
        </div>

        {/* Divider */}
        <div style={{ borderTop: `1px solid ${C.border}`, marginBottom: '32px' }} />

        {/* NDA Body */}
        <div>
          <h1 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 28, marginBottom: 8 }}>
            Casavio Beta Non-Disclosure Agreement
          </h1>

          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.muted, fontSize: 14, marginBottom: 24, fontStyle: 'italic' }}>
            Effective on the date you accept this agreement at signup.
          </p>

          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            This Non-Disclosure Agreement ("Agreement") governs your participation
            in the Casavio private beta program. By checking the acceptance box at
            signup, you ("Recipient") agree to the terms below with Kenneth Krummes,
            the founder of Casavio ("Company").
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            1. Purpose
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            Company is sharing access to the Casavio platform, product roadmap,
            business strategy, and related materials with Recipient so that Recipient
            can evaluate the product, provide feedback, and help shape the product
            before public launch.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            2. Confidential Information
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 12 }}>
            "Confidential Information" means any non-public information about
            Casavio that Recipient learns through participation in the beta,
            including but not limited to:
          </p>
          <ul style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16, paddingLeft: 24 }}>
            <li>The Casavio product, features, user interface, and unreleased functionality</li>
            <li>The business plan, pricing strategy, financial projections, and revenue model</li>
            <li>Technology architecture, integrations, vendor relationships, and source code</li>
            <li>Marketing strategy, branding, positioning, and target market plans</li>
            <li>Advisor identities, customer lists, and partner relationships</li>
            <li>Any documents, screens, demos, or communications marked or reasonably understood to be confidential</li>
          </ul>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            3. Obligations
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 12 }}>
            Recipient agrees to:
          </p>
          <ul style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16, paddingLeft: 24 }}>
            <li>Hold Confidential Information in strict confidence</li>
            <li>Not disclose Confidential Information to any third party without Company's prior written consent</li>
            <li>Not use Confidential Information for any purpose other than evaluating and providing feedback on Casavio</li>
            <li>Not publicly post screenshots, recordings, or descriptions of the beta product without Company's prior written consent</li>
            <li>Not reverse engineer, replicate, or independently develop a competing product based on Confidential Information</li>
            <li>Promptly notify Company of any unauthorized use or disclosure</li>
          </ul>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            4. Exclusions
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            Confidential Information does not include information that: (a) is or
            becomes publicly available through no fault of Recipient; (b) was
            already known to Recipient without confidentiality obligations before
            receiving it from Company; (c) is independently developed by Recipient
            without use of Confidential Information; or (d) is required to be
            disclosed by law or court order, provided Recipient gives Company
            reasonable advance notice when legally permitted.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            5. Feedback
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            Any feedback, suggestions, ideas, or improvements Recipient provides
            about Casavio ("Feedback") may be used by Company without restriction
            or compensation. Recipient grants Company a perpetual, irrevocable,
            worldwide, royalty-free license to use Feedback for any purpose,
            including incorporating it into the product. Recipient retains no
            ownership claim over Feedback once shared.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            6. No License
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            Nothing in this Agreement grants Recipient any ownership, license, or
            rights in the Casavio product, trademarks, or Confidential Information.
            All rights are reserved by Company.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            7. Term
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            This Agreement remains in effect for two (2) years from the date of
            acceptance, or until Casavio publicly launches and the relevant
            information becomes public, whichever comes first. Recipient's
            obligations regarding any information that remains non-public after
            that period survive termination.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            8. No Obligation
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            This Agreement does not obligate either party to enter into any further
            business relationship, employment relationship, or transaction. It does
            not create a partnership, joint venture, or agency relationship.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            9. Governing Law
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            This Agreement is governed by the laws of the State of California,
            without regard to its conflict of laws principles. Any disputes will be
            resolved in the state or federal courts located in Marin County,
            California.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            10. Remedies
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            Recipient acknowledges that unauthorized disclosure of Confidential
            Information would cause irreparable harm to Company for which monetary
            damages would be inadequate. Company is entitled to seek injunctive
            relief in addition to any other available remedies.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            11. Entire Agreement
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            This Agreement is the entire understanding between the parties
            regarding the confidentiality of beta program information. It
            supersedes any prior oral or written agreements on the same subject.
          </p>

          <h2 style={{ fontFamily: 'Georgia, serif', color: C.brown, fontSize: 20, marginTop: 24, marginBottom: 8 }}>
            12. Acceptance
          </h2>
          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.brown, lineHeight: 1.6, marginBottom: 16 }}>
            By checking the "I agree to the Casavio Non-Disclosure Agreement" box
            at signup, Recipient acknowledges that they have read, understood, and
            agree to be bound by this Agreement. The acceptance and timestamp are
            recorded in Recipient's Casavio account.
          </p>

          <p style={{ fontFamily: 'Calibri, sans-serif', color: C.muted, fontSize: 13, marginTop: 32, fontStyle: 'italic', textAlign: 'center' }}>
            Questions about this agreement? Email kennethkrummes@gmail.com.
          </p>
        </div>

        {/* Divider */}
        <div style={{ borderTop: `1px solid ${C.border}`, margin: '36px 0 28px' }} />

        {/* Footer actions */}
        <div className="no-print" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <p style={{ fontSize: '13px', color: C.muted, fontFamily: 'Calibri, sans-serif', margin: 0 }}>
            Effective upon acceptance at signup.
          </p>
          <button
            onClick={() => window.print()}
            style={{
              background: 'transparent', border: `1px solid ${C.border}`,
              borderRadius: '8px', padding: '10px 20px',
              fontSize: '13px', color: C.muted,
              fontFamily: 'Georgia, serif', cursor: 'pointer',
              letterSpacing: '1px',
            }}
          >
            Print / Save PDF
          </button>
        </div>
      </div>
    </div>
  )
}
